import classes from './button.module.css'

const Button = {
  defaultProps: {
    variant: 'filled',
    radius: 'sm',
    fw: 500,
  },
  classNames: {
    root: classes.root,
  },
}

export default Button
